export default "__VITE_ASSET__BajmJSsA__"